import Link from "next/link";
import React from "react";

import { useModal } from "../../context/modal-context";
import { useAudioPlayer } from "../../context/audio-player-context";

type Props = {
  song: Song;
  play: () => void;
};

export default function SongListItem(props: Props) {
  const { skiza } = useModal();
  const { song: currentSong } = useAudioPlayer();

  const song = props.song || ({} as Song);

  return (
    <div className="flex items-center bg-gray-200 rounded-md">
      <div className="w-[75px] h-[85px] sm:w-[85px]">
        <img
          onClick={props.play}
          src={song.image?.url || "/angaza-logo.png"}
          alt=""
          className="object-cover object-center w-full h-full rounded-l-md"
        />
      </div>

      <div className="flex flex-col justify-center flex-1 px-3 py-2">
        <Link href={`/songs/${song.id}`}>
          <p className="text-xs font-bold leading-4 line-clamp-1">{song.title}</p>
        </Link>
        <p className="leading-4 text-gray-500 text-xxs font-bolld line-clamp-1">{song.author}</p>

        <div className="flex items-center">
          <button
            onClick={() => skiza.open(song)}
            className="px-4 py-1.5 mt-2 text-xs sm:text-sm font-semibold text-green-500 bg-white rounded-md disabled:bg-gray-400"
          >
            <p className="line-clamp-1">Set Skiza</p>
          </button>

          <div className="flex-1"></div>
        </div>
      </div>

      <div className="pr-3">
        {currentSong?.id === song.id ? (
          <div className="text-orange">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"
              />
            </svg>
          </div>
        ) : (
          <button
            onClick={props.play}
            type="button"
            className={`flex-shrink-0 -mr-1.5 w-10 h-10 sm:w-12 sm:h-12 play-btn`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-10 h-10 sm:w-12 sm:h-12 "
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
